<template>
    <div>
        <div class="pagination toolbox-item" v-if="totalPages > 1">
            <div class="page-item" v-if="currentPage !== 1">
                <a class="page-link page-link-arrow page-link-btn" tabindex @click="hasOnPageChangeListener ? $emit('onPageChange', {page: currentPage - 1}) : applyFilters({page: currentPage - 1})">
                    <i class="icon-angle-left"></i>
                </a>
            </div>
            <div class="d-flex" v-if="(firstPartLength !== pagesShowLength && totalPages !== pagesShowLength ) || (currentPage < firstPartLength)">
                <div v-for="page in firstPartLength" :key="page" v-bind:class="{ active: currentPage === page }" class="page-item">
                    <a class="page-link" tabindex @click="hasOnPageChangeListener ? $emit('onPageChange', {page}) : applyFilters({page})">{{ page }}</a>
                </div>
            </div>

            <div class="page-item" v-if="(currentPage >= firstPartLength) && totalPages > pagesShowLength + 2">
                <span class="page-link" v-if="currentPage !== 5">...</span>
                <a class="page-link" v-if="currentPage === 5" tabindex @click="hasOnPageChangeListener ? $emit('onPageChange', {page:2}) : applyFilters({page:2})">{{ 2 }}</a>
            </div>

            <div v-if="(currentPage >= firstPartLength) && currentPage <= (totalPages - pagesShowLength + 1)" class="d-flex">
                <div v-for="page in totalPages" :key="page" v-bind:class="{ active: currentPage === page }" class="page-item"
                     v-if=" (currentPage >= page - 2 && currentPage <= page + 2)"
                >
                    <a class="page-link" tabindex @click="hasOnPageChangeListener ? $emit('onPageChange', {page}) : applyFilters({page})">{{ page }}</a>
                </div>
            </div>

            <div class="page-item" v-if="totalPages > pagesShowLength + 2 && currentPage <= totalPages - pagesShowLength + 1">
                <span class="page-link" v-if="currentPage !== totalPages - pagesShowLength + 1">...</span>
                <a class="page-link" v-if="currentPage === totalPages - pagesShowLength + 1" tabindex @click="hasOnPageChangeListener ? $emit('onPageChange', {page:totalPages - 1}) : applyFilters({page:totalPages - 1})">{{ totalPages - 1 }}</a>
            </div>

            <div class="mr-1 d-flex" v-if="lastPartLength > 0">
                <div v-for="page in totalPages" v-if="page > totalPages - lastPartLength" :key="page" v-bind:class="{ active: currentPage === page }" class="page-item">
                    <a class="page-link" tabindex @click="hasOnPageChangeListener ? $emit('onPageChange', {page}) : applyFilters({page})">{{ page }}</a>
                </div>
            </div>

            <div class="page-item" v-if="totalPages !== currentPage">
                <a class="page-link page-link-arrow page-link-btn" tabindex @click="hasOnPageChangeListener ? $emit('onPageChange', {page: currentPage + 1}) : applyFilters({page: currentPage + 1})">
                    <i class="icon-angle-right"></i>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
    props: ['total', 'perPage', 'page'],
    data() {
        return {
            pagesShowLength: 5,
        }
    },

    methods: {
        ...mapActions(['applyFilters']),
    },
    computed: {
        totalPages() {
            return Math.ceil(this.total / (this.perPage || this.$store.state.filters.perPage || 24));
        },
        currentPage() {
            return this.page || this.$store.state.filters.page || 1;
        },
        hasOnPageChangeListener(){
            return this.$listeners && this.$listeners.onPageChange
        },
        firstPartLength() {
            return this.totalPages > (this.pagesShowLength + 2) ? (this.currentPage >= this.pagesShowLength ? 1 : this.pagesShowLength) : this.totalPages
        },
        lastPartLength() {
            return this.totalPages > (this.pagesShowLength + 2) ? (this.currentPage <= this.totalPages - this.pagesShowLength + 1 ? 1 : this.pagesShowLength) : 0
        }
    }
}
</script>
